import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import { Addendum } from "@/core/types";

import { addendumKeys } from "../keyFactory";
import {
  type UpdateNoteAddendumVariables,
  updateNoteAddendum,
} from "../queryFunctions/updateNoteAddendum";

export function useUpdateNoteAddendum({
  onSuccess,
  ...options
}: UseMutationOptions<Addendum, unknown, UpdateNoteAddendumVariables> = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateNoteAddendum,
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({
        queryKey: addendumKeys.byNote(variables.noteId),
      });
      onSuccess?.(data, variables, context);
    },
  });
}
